import { render } from "./Modal.vue?vue&type=template&id=48745850"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=48745850&lang=css"

import exportComponent from "/var/www/kutchinaasp-uat.kutchina.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__